import { Col } from 'reactstrap';
import ComponentCard from '../../layouts/containers/ComponentCard';
import FormularioNuevaFactura from '../../components/facturas/FormularioNuevaFactura';

const NuevaFactura = () => {
  return (
    <Col md="12">
      <ComponentCard title="Nueva factura" hasButton>
        <FormularioNuevaFactura />
      </ComponentCard>
    </Col>
  );
};

export default NuevaFactura;
